import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="32px">
    <g><rect fill="none" height="24" width="24" /></g>
    <g><g><g><path d="M20,9H4v2h16V9z M4,15h16v-2H4V15z" /></g></g></g>
  </svg>
);
